import angular from 'angular';

import AuthorizedComponent from './authorized.cmpt';
import AuthorizedSceneModule from './scene';

export default angular
    .module('application.scene.authorized', [
        AuthorizedSceneModule.name
    ])
    .component(AuthorizedComponent.selector, AuthorizedComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized', {
        url: '',
        template: '<db-a-authorized class="block-component"></db-a-authorized>',
        redirectTo: 'authorized.calendar',
        data: {
            requires: {
                authentication: {
                    state: 'identity.sign-in',
                    keep: true
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/index.js